export const interpolate = (templateString, params) => {
    const names = Object.keys(params);
    const vals = Object.values(params);
    return new Function(...names, `return \`${templateString}\`;`)(...vals);
}

